/// <reference path='../integrations.module.ts' />
/// <reference path='../../../../../typings/index.d.ts' />

module Meevo.Plugins.Integrations {
    import IIntegrationErrorLogDetail = Meevo.Model.IIntegrationErrorLogDetail;
    import IIntegrationErrorLogDetailFailed = Meevo.Model.IIntegrationErrorLogDetailFailed;
    import IIntegrationErrorLogDetailSuccessful = Meevo.Model.IIntegrationErrorLogDetailSuccessful;
    import IntegrationStatusEnum = Meevo.Model.IntegrationStatusEnum;
    import IIntegrationErrorHeader = Meevo.Model.IIntegrationErrorHeader;

    class ExpandedDetailModalController {
        public logItem: IIntegrationErrorHeader;
        public itemDetail: IIntegrationErrorLogDetail = {};
        public showPayload = false;

        static $inject = [
            '$mdDialog',
            'meevo.components.busy.BusyService',
            'meevo.components.common.DataService',
            'meevo.AppSettings'
        ];

        constructor(
            protected $mdDialog: ng.material.IDialogService,
            protected busyService: Meevo.Components.Busy.IBusyService,
            protected dataService: Meevo.Components.BaseClasses.IDataService,
            protected appSettings: Components.Common.IAppSettings
        ) {
            this.getErrorDetails(this.logItem.integrationQueue_TId);
        }

        /**
         * Get error details by id
         */
        private getErrorDetails(logItemId: number): void {
            let url = `${this.appSettings.API_ROOT}/${this.appSettings.API_ENDPOINTS.integration}/ErrorLog/${logItemId}`;

            this.busyService.start();
            this.dataService.customMethodData(url, 'GET', {})
                .then(response => {
                    let data = <IIntegrationErrorLogDetail>response.data;


                    data.failed.forEach((item: IIntegrationErrorLogDetailFailed) => {
                        item.parsedDateCreated = moment(item.dateCreated).format("ddd, MMM D, YYYY h:mm:ss A");
                    });

                    data.successful.forEach((item: IIntegrationErrorLogDetailSuccessful) => {
                        item.parsedSuccessDate = moment(item.successDate).format("ddd, MMM D, YYYY h:mm:ss A");
                    });

                    this.itemDetail.failed = data.failed;
                    this.itemDetail.successful = data.successful;
                    //this.itemDetail.payload = JSON.stringify(data.payload, null, "    ");
                    //this.itemDetail.payload = data.payload;
                    if (data.payload == null || data.payload === "" || data.payload == undefined) {
                        this.itemDetail.payload = "*** NO CONTENT ***";
                    }
                    else {
                        this.itemDetail.payload = JSON.stringify(JSON.parse(data.payload), null, 4);
                    }
                })
                .finally(() => {
                    this.busyService.stop();
                });
        }

        /**
         * Resubmit the Integration
         */
        public resubmit(): void {
            let url = `${this.appSettings.API_ENDPOINTS.integration}/ErrorLog`,
                entity = angular.extend(this.logItem, {
                    isResubmitting: true,
                    isSkipping: false,
                    eventSource: 'Event Resubmit'
                });

            this.busyService.start();
            this.dataService.add(url, entity)
                .then(() => {
                    this.$mdDialog.hide();
                    this.busyService.stop();
                });
        }

        /**
          * Skip the Integration
          */
        public skip(): void {
            let url = `${this.appSettings.API_ENDPOINTS.integration}/ErrorLog`,
                entity = angular.extend(this.logItem, {
                    isResubmitting: false,
                    isSkipping: true,
                    eventSource: 'Event Skip'
                });

            this.busyService.start();
            this.dataService.add(url, entity)
                .then(() => {
                    this.$mdDialog.hide();
                    this.busyService.stop();
                });
        }

        public toggleDetails(): void {
            this.showPayload = !this.showPayload;
        }


        /**
         * Close modal window
         * */
        public closeModal(): void {
            this.$mdDialog.cancel();
        }

        get integrationStatusEnum(): any {
            return IntegrationStatusEnum;
        }
    }

    angular.module('meevo.plugins.integrations')
        .controller('meevo.plugins.integrations.ExpandedDetailModalController', ExpandedDetailModalController);
}
